import React from "react";
import PropTypes from "prop-types";
import { Container } from "reactstrap";

import Box from "@material-ui/core/Box";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Header from '../header/Header';
import MarkdownViewer from "./MarkdownViewer";

import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';

import './MarkdownViewer.css';

import "./HelpAbout.css";


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{ width: "fit-content" }}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
export default function HelpAbout(props) {
  const [value, setValue] = React.useState(0);

  //   const language = props.location.state.data;

  const filePath = "./UsersGuide_en.md";
  const [markdown, setMarkdown] = React.useState('');


  React.useEffect(() => {
    fetch(filePath)
      .then((response) => response.text())
      .then((text) => {
        console.log("**", text);
        setMarkdown(text);
        console.log("** state updated", markdown);
      })
      .catch((error) => console.log(error));
  }, [filePath]);


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Container style={{ marginLeft: '75px' }}>
      <Header />
      {/* <Tabs value={value} onChange={handleChange} centered style={{ marginTop: '75px', width: '100%' }}>
        <Tab
          className="headerTabs"
          label="User's Guide"
          {...a11yProps(0)}
        /> */}
      {/* <Tab className="headerTabs" label="Release Notes" {...a11yProps(1)} /> */}
      {/* </Tabs> */}
      <TabPanel value={value} index={0}>
        <ReactMarkdown
          className="markdownViewer"
          remarkPlugins={[[gfm, { tablePipeAlign: true, tableCellPadding: true }]]}>
          {markdown}
        </ReactMarkdown>
      </TabPanel>
      {/* <TabPanel value={value} index={1}>
        <MarkdownViewer markdownFilePath="./ReleaseNotes.md" />
      </TabPanel> */}
    </Container >
  );
}
